import { useCallback, useState } from 'react';
import securedAxios from '../../../utils/secured-axios';
import { fetchCsrfToken } from '../../../infrastructure/api';

export const useResendVerificationMail = () => {
  const [isValidating, setIsValidating] = useState(false);

  const resendVerificationMail = useCallback(async () => {
    setIsValidating(true);

    try {
      const csrfToken = await fetchCsrfToken();
      const res = await securedAxios.post(
        '/users/verification_mail.json',
        {},
        {
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
            Accept: 'application/json',
            'X-CSRF-Token': csrfToken,
          },
        },
      );

      if (res.status === 200) {
        return { success: true };
      } else {
        return { success: false };
      }
    } catch (error) {
      return { success: false };
    } finally {
      setIsValidating(false);
    }
  }, []);

  return { isValidating, resendVerificationMail };
};
